package ai.wagemix.net.client

import ai.wagemix.net.models.WMCheckoutSessionCreate
import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/billing/checkout-sessions`: a Stripe Checkout session for the signed-in, verified user. */
class WMCreateCheckoutSessionRequestBuilder: FSAuthenticatedRequestBuilder<WMCreateCheckoutSessionRequestBuilder, WMCheckoutSessionCreate>() {

    override fun build(): FSRequest<WMCheckoutSessionCreate> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "billing", "checkout-sessions")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMCreateCheckoutSessionRequestBuilder = this
}
